import { render, staticRenderFns } from "./CircleDocumentsV2.vue?vue&type=template&id=2558e796&scoped=true"
import script from "./CircleDocumentsV2.vue?vue&type=script&lang=js"
export * from "./CircleDocumentsV2.vue?vue&type=script&lang=js"
import style0 from "./CircleDocumentsV2.vue?vue&type=style&index=0&id=2558e796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558e796",
  null
  
)

export default component.exports